import React from "react"
import "./about_card.scss"

import Card from "react-bootstrap/Card"
import Image from "react-bootstrap/Image"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons"
import { faGithub } from "@fortawesome/free-brands-svg-icons"
import ProfileImage from "../images/profile_2.jpeg"

export default function AboutCard(props) {
  return (
    <Card className="about-card">
      <Card.Body>
        <Image className="profile" src={ProfileImage} roundedCircle fluid />
        <Card.Title className="name">
          Milla
          <br />
          Samuel
        </Card.Title>
        <div className="divider"></div>
        <Card.Text className="job">SOFTWARE ENGINEER</Card.Text>
      </Card.Body>

      <Card.Footer className="footer">
        <span className="socials">
          <a
            href="mailto:msamuel001@e.ntu.edu.sg"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <FontAwesomeIcon icon={faEnvelope} />
          </a>{" "}
          <a
            href="https://www.linkedin.com/in/millasml/"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>{" "}
          <a
            href="https://github.com/millasml/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faGithub} />{" "}
          </a>
        </span>
      </Card.Footer>
    </Card>
  )
}
